"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1() {
    let hasTouchScreen = false;
    let navigator = window.navigator;
    if ("maxTouchPoints" in navigator) {
        hasTouchScreen = navigator.maxTouchPoints > 0;
    }
    else if ("msMaxTouchPoints" in navigator) {
        // @ts-ignore
        hasTouchScreen = (navigator === null || navigator === void 0 ? void 0 : navigator.msMaxTouchPoints) > 0;
    }
    else {
        // @ts-ignore (sorry not sorry)
        let mQ = window.matchMedia && matchMedia("(pointer:coarse)");
        if (mQ && mQ.media === "(pointer:coarse)") {
            hasTouchScreen = !!mQ.matches;
        }
        else if ("orientation" in window) {
            hasTouchScreen = true;
        }
        else {
            let UA = window.navigator.userAgent;
            hasTouchScreen = true;
        }
    }
    return hasTouchScreen;
}
exports.default = default_1;
